import { getConfiguration } from '@chr/common-web-ui-configuration';
import { useEffect, useState } from 'react';

export function useConfiguration() {
  const [config, setConfig] = useState<AppConfig | null>(null);

  useEffect(() => {
    const fetchConfig = async () => {
      const config = await getConfiguration<AppConfig>();
      setConfig(config);
    };
    fetchConfig();
  }, []);

  return config;
}